import Swiper from 'swiper/bundle'

/**
 * Initializes the Swiper carousel for the "How to Use" section
 * on mobile view using the `.swiper-sonicsmooth-how-to-use-mobile` container.
 */
const initCarousel = () => {
  new Swiper('.swiper-sonicsmooth-how-to-use-mobile', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    mousewheel: {
      enabled: true
    },
    navigation: {
      nextEl: '.sonicsmooth-how-to-use-mobile__button-next',
      prevEl: '.sonicsmooth-how-to-use-mobile__button-prev'
    },
    pagination: {
      el: '.sonicsmooth-how-to-use-mobile__pagination',
      clickable: true
    }
  })
}

/**
 * Initializes the modal video player functionality.
 * Handles open/close behavior, video playback, and user interaction.
 */
const initVideoModal = () => {
  // Choose the correct trigger button based on screen width
  let openBtn = null
  if (window.innerWidth < 1280) {
    openBtn = document.querySelector('.sonicsmooth-how-to-use-mobile__image')
  } else {
    openBtn = document.querySelector('.sonicsmooth-how-to-use-desktop__image')
  }

  // Modal and control elements
  const modal = document.getElementById('htu-video-modal-pdm')
  const closeBtn = document.querySelector('.htu-video-modal-close-pdm')
  const videoEl = document.getElementById('htu-video-pdm')
  const playBtn = document.getElementById('htu-play-btn-pdm')

  // Exit early if any required elements are missing
  if (!openBtn || !modal || !closeBtn || !videoEl || !playBtn) {
    console.warn(
      'One or more elements are missing for the video modal functionality.',
      'openBtn:', openBtn,
      'modal:', modal,
      'closeBtn:', closeBtn,
      'videoEl:', videoEl,
      'playBtn:', playBtn
    )
    return
  }

  // Show modal when trigger is clicked
  openBtn.addEventListener('click', () => {
    modal.style.display = 'flex'
  })

  // Close modal, reset video, and show play button
  closeBtn.addEventListener('click', () => {
    modal.style.display = 'none'
    videoEl.pause()
    videoEl.currentTime = 0
    playBtn.style.display = 'block'
  })

  // Start video playback on play button click and hide button
  playBtn.addEventListener('click', function () {
    try {
      videoEl.play()
      this.style.display = 'none'
    } catch (error) {
      console.error('Error trying to play the video:', error)
    }
  })

  // Toggle play/pause and play button visibility when video is clicked
  videoEl.addEventListener('click', function () {
    if (!videoEl.paused) {
      videoEl.pause()
      playBtn.style.display = 'block'
    } else {
      videoEl.play()
      playBtn.style.display = 'none'
    }
  })

  // Close modal and reset video when clicking outside the video container
  window.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.style.display = 'none'
      videoEl.pause()
      videoEl.currentTime = 0
      playBtn.style.display = 'block'
    }
  })
}

/**
 * Initializes the "How to Use" Swiper and video modal for the
 * SonicSmooth Pro Plus 12 product page on mobile devices.
 */
export const swiperHowToUseSonnicsmooth = () => {
  // Only execute on the correct page
  const isCorrectPage = window.location.href.includes('/pages/sonicsmooth-pro-plus-12')

  // Initialize modal functionality on all screen sizes
  initVideoModal()

  // Only proceed with carousel setup on mobile devices
  const isMobile = window.innerWidth <= 1280
  if (!isCorrectPage || !isMobile) {
    return
  }

  // Ensure the Swiper container exists
  const swiperContainer = document.querySelector('.swiper-sonicsmooth-how-to-use-mobile')
  if (!swiperContainer) {
    return
  }

  // Initialize Swiper
  initCarousel()
}
